import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AppLayout } from "./components/layout/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Goals from "./pages/Goals";
import GoalDetail from "./pages/GoalDetail";
import DailyPlan from "./pages/DailyPlan";
import Users from "./pages/Users";
import Meetings from "./pages/Meetings";
import Templates from "./pages/Templates";
import TeamTargets from "./pages/TeamTargets";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/goals/:goalId" element={<GoalDetail />} />
            <Route path="/daily-plan" element={<DailyPlan />} />
            <Route path="/users" element={<Users />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/team-targets" element={<TeamTargets />} />
            <Route path="/platform" element={<SuperAdminDashboard />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
